import { Intent } from 'signup-constants/Intent';
import { getFlowConfig, getFlowSteps } from '../../flow-initial/getFlowConfig';
import { FlowManager } from '../../flow-management/FlowManager';
import { getIntentKey } from '../../routing/getIntentKey';
import { updateFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const BranchCampaignAssistant = {
  name: 'BranchCampaignAssistant',
  stateCheck: () => {
    return getIntentKey() === Intent.campaignAssistant;
  },
  rebuildFlow: (flow, state, dispatch) => {
    const currentFlow = getFlowSteps();
    const postAccountCreationSteps = FlowManager.removeSteps(Step.CrmExperienceLevel)(currentFlow.postAccountCreation);
    const flowSteps = FlowManager.removeSteps(Step.CrmExperienceLevel)(flow);
    dispatch(updateFlow(currentFlow.preVerification, currentFlow.postVerification, postAccountCreationSteps, currentFlow.postExistingAccountSelection));
    getFlowConfig().shouldHalveProgressBar = true;
    return flowSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};